export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-ext-400-normal.woff2?0fa030ec377f0693a1bcc42f56b8902f";